import { SITE_DOMAIN } from "../../constants/global";

interface BannerProps {
  slug: string;
  size?: "default" | "large";
  color?: "purple" | "white";
}

function SocialIcons(props: BannerProps) {
  const { slug, size = "default", color = "purple" } = props;
  const socials = [
    {
      name: "discord",
      href: "https://discord.com/invite/ledger",
      img:
        color === "purple"
          ? "/icons/Quest/discord.svg"
          : "/icons/Quest/discord-white.svg",
    },
    {
      name: "twitter",
      href: `http://www.twitter.com/intent/tweet?url=${SITE_DOMAIN}quests/${slug}`,
      img:
        color === "purple"
          ? "/icons/Quest/twitter.svg"
          : "/icons/Quest/twitter-white.svg",
    },
    {
      name: "linkedin",
      href: `https://www.linkedin.com/shareArticle?mini=true&url=${SITE_DOMAIN}quests/${slug}`,
      img:
        color === "purple"
          ? "/icons/Quest/linkedin.svg"
          : "/icons/Quest/linkedin-white.svg",
    },
  ];

  return (
    <>
      {socials.map((social) => (
        <a
          href={social.href}
          target="_blank"
          rel="noreferrer"
          className={`${
            color === "purple" ? "hover:bg-purple" : "hover:bg-white"
          } hover:rounded-full`}
          key={social.name}
        >
          <img
            src={social.img}
            className={`cursor-pointer hover:brightness-0 ${
              size === "large" ? "h-12" : ""
            }`}
            alt={social.name}
          />
        </a>
      ))}
    </>
  );
}

export default SocialIcons;
